import {Component} from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import {UtilsService} from '@services/utils/utils.service';
import {MenuOverviewComponent} from '@components/sidebar/menu-overview/menu-overview.component';
import {User} from '@models/user/user';
import {Role} from '@models/user/role';
import {MenuItem} from '@models/sidebar/menu-item';
import {FavoritesComponent} from '@components/sidebar/favorites/favorites.component';
import {FirebaseAuthenticationService} from '@services/firebase/auth/firebase-authentication.service';

@Component({
    selector: 'scitis-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent {

  public isAdminRole = false;
  public isSuperAdminRole = false;
  public isTechAdminRole = false;
  public firebaseUserId: string = '';
  public userGroupId: number = -1;
  public userRole: Role = new Role(new User());
  public whiteListedMachineryGroups: null | number[] = null;
  public whiteListedMachineryGroupsMap: null | { [p: number]: boolean } = null;
  private CURRENT_PAGE_NAME = 'SideBar';

  constructor(
      private firebaseAuthenticationService: FirebaseAuthenticationService,
      private utilsService: UtilsService) {
    this.setAuthenticatedUserRoleAndOrganization();
  }

  get isAdminOrHigher(): boolean {
    return this.utilsService.isAdminOrHigher(this.isAdminRole, this.isTechAdminRole, this.isSuperAdminRole);
  }

  get isHigherThanAdmin(): boolean {
    return this.utilsService.isHigherThanAdmin(this.isTechAdminRole, this.isSuperAdminRole);
  }

  onMenuItemSelected(menuItem: MenuItem, overview: MenuOverviewComponent, favorites: FavoritesComponent): void {
    overview.resetExpandedNode();
    overview.onMenuItemSelectedFromOutside(menuItem);
    overview.isOverviewCollapsed = false;
    favorites.isFavoritesCollapsed = true;
  }

  onExpandFavorites(overview: MenuOverviewComponent): void {
    overview.isOverviewCollapsed = true;
  }

  onExpandOverview(favorites: FavoritesComponent): void {
    favorites.isFavoritesCollapsed = true;
  }

  private setAuthenticatedUserRoleAndOrganization() {
    this.firebaseAuthenticationService.getLoggedUserDetails().subscribe({
      next: (user: User) => {
        this.userRole = new Role(user);
        this.firebaseUserId = user.firebaseUid;
        this.userGroupId = user.machineGroup;
        this.isSuperAdminRole = this.userRole.isSuperAdminRole;
        this.isAdminRole = this.userRole.isAdminRole;
        this.isTechAdminRole = this.userRole.isTechAdminRole;
        const isWhiteListedUser = user.isWhiteListedUser();
        this.whiteListedMachineryGroups = this.userRole.isSuperAdminRole || !isWhiteListedUser ? null : user.getWhiteListedMachineryGroups(false);
        this.whiteListedMachineryGroupsMap = this.userRole.isSuperAdminRole || !isWhiteListedUser ? null : user.whiteListedMachineryGroupsMap;
      }, error: (error: HttpResponse<any>) => {
        console.error(`${this.CURRENT_PAGE_NAME}. Error getting current user details.`, JSON.stringify(error));
      }
    });
  }

}
